import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { setDialogMailRegisteredVisible, setLoginVisible } from "../Slice/DialogSlice";
import { useSelector } from "react-redux";
import { RootState, AppDispatch } from "../Store";
import { useDispatch } from "react-redux";


export default function AuthDialogMailRegistered() {

    const mailRegisteredVisible = useSelector((state: RootState) => state.authReducer.dialog.mailRegisteredVisible);
    const dispatch = useDispatch<AppDispatch>();

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <div className="font-bold white-space-nowrap">Login</div>
            <div>
                <h3>Thank you very much! Your email address has been confirmed.</h3>
            </div>
        </div>
    );

    const footerContent = (
        <div>
            <Button
                label="LOGIN"
                onClick={() => {
                    dispatch(setDialogMailRegisteredVisible(false));
                    dispatch(setLoginVisible(true));
                }} />
        </div>
    );

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={mailRegisteredVisible}
            style={{ width: '50vw' }}
            onHide={() => dispatch(setDialogMailRegisteredVisible(false))}
        >
            <i className={classNames("pi pi-check-circle")} style={{ fontSize: '2.5rem' }}></i>
            <p>
                Your email has been successfully confirmed! After verification, 
                you can start searching and posting a new space.
            </p>
        </Dialog>
    )
}